import http from "@/utils/http";
/**
 * 素材裁剪
 * **/
export async function crop(data): Promise<any> {
  try {
    const res = await http.post("/api/v1/space/material/crop", data);
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getCropDetail(id) {
  try {
    const res = await http.get(`/api/v1/space/material/crop/${id}`);
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getSnapshot(params) {
  try {
    const res = await http.get(`/api/v1/space/media/frame_snapshot`, {
      params,
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}
// 获取文案库列表
export async function getTextLibraryApi(params) {
  return http.get("/api/v1/script/repo", { params });
}

//获取特效分类列表
export async function getEffectCategoryApi() {
  return http.get("/api/v1/editing/effect/category");
}
// 获取特效列表
export async function getEffectListApi(params) {
  const res = await http.get("/api/v1/editing/effect", { params });
  const items = res?.data?.items?.map((item) => {
    return {
      ...item,
      url: res?.data?.base_url + "/" + item.cover_url,
    };
  });
  return {
    data: items,
    total: res?.data?.items?.length || 0,
  };
}

// tts 文字转语音
export async function tts(data): Promise<any> {
  try {
    const res = await http.post("/api/v1/editing/tts", data);
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

// tts 文字转语音
export async function autioToText(params): Promise<any> {
  try {
    const res = await http.get("/api/v1/editing/stt", { params });
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

// 贴纸收藏
export async function stickerFavor(data): Promise<any> {
  try {
    const res = await http.post("/api/v1/editing/sticker/favorite", data);
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getFavorStickerList(params) {
  try {
    const res = await http.get("/api/v1/sticker/favorite", { params });
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getBubbleCtgr() {
  try {
    const res = await http.get("/api/v1/editing/bubble/category");
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getBubbleList(params) {
  try {
    const res = await http.get("/api/v1/editing/bubble", { params });
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getFilterCtgr() {
  try {
    const res = await http.get("/api/v1/editing/filter/category");
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}

export async function getFilterList(params) {
  try {
    const res = await http.get("/api/v1/editing/filter", { params });
    if (res) {
      console.log(res);

      return res;
    } else {
      console.log("接口错误!");
    }
  } catch (err) {
    console.log(err);
  }
}
